"use strict";

angular.module("vendor")
.controller("CloneConfirmationController", function($scope, $attrs, close, FormError) {
    this.referenceModel = $attrs.referenceModel;
    this.service = $attrs.service;

    this.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        if (confirm)
            close.apply(this, arguments);
    };

    this.submit = function() {
        this.submitted = true;

        this.service.clone(this.referenceModel, $scope.formConfirm).finally(function() {
            $scope.$element.modal("hide");
            $scope.$element.remove();
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/btn-clone/confirmation.modal.js
// module id = 898
// module chunks = 0